import React, {Component} from 'react';
import {connect} from 'react-redux';
import LayoutFooter from '../../components/layoutFooter';

class LayoutFooterHOC extends Component {
    render() {
        return (
            <LayoutFooter locationPathName={this.props.locationPathName} push={this.props.pushStart}
                          backEndVersion={this.props.backEndVersion}
            />
        )
    }
}

const mapStateToProps  = (state) => {
    return {
        locationPathName: state.router.location.pathname,
        backEndVersion: state.user.version
    }
};

const mapDispatchToProps = (dispatch) => {
    return {

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutFooterHOC);